import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MasterService } from "../../master/services/master-service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GrievanceDetailsService } from "src/app/shared/grievance-details-popup/grievance-details.service";

@Component({
  selector: "app-counselor-dashboard",
  templateUrl: "./counselor-dashboard.component.html",
  styleUrls: ["./counselor-dashboard.component.scss"],
})
export class CounselorDashboardComponent implements OnInit {
  counselorForm: FormGroup;
  nameValue: any;
  grieveanceDetailsData: any;
  modalBool: boolean = false;
  type: string = "counselor-dashboard";

  constructor(
    private spinner: NgxSpinnerService,
    private masterService: MasterService,
    private fb: FormBuilder,
    private grievanceDetailsPopupModal: GrievanceDetailsService
  ) { }

  ngOnInit() {
    this.validatorRule();
  }

  validatorRule() {
    this.counselorForm = this.fb.group({
      searchBox: [
        "",
        [Validators.required, Validators.pattern(/^FE\/\d{2,}\/\d{8}\/\d{2,}$/)],
      ],
    });
  }

  get counselorF() {
    return this.counselorForm.controls;
  }

  getcomplaintDeatails() {
    this.modalBool = true;
    this.nameValue = this.counselorForm.value.searchBox;

    this.masterService
      .getcounselorData(
        "counsellor/grievance_details" + "?complain_id=" + this.nameValue
      )
      .subscribe(
        (response) => {
          if (response["status"] == 200) {
            this.grieveanceDetailsData = response["data"][0];
            this.openModal();
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  /* Function for Opening the Popup Model*/
  openModal() {
    this.grievanceDetailsPopupModal.open();
  }
}
